// extracted by mini-css-extract-plugin
export default {"drag-and-drop-container":"DragAndDropProvider_drag-and-drop-container__vHHeJ"};